// Color palette definition
// These are the base colors used throughout the application

const colors = {
  // Primary brand colors
  primary: {
    main: '#DA0000',
    light: '#FF3333',
    dark: '#A80000',
    contrastText: '#FFFFFF',
  },
  
  // Secondary colors
  secondary: {
    main: '#333333',
    light: '#555555',
    dark: '#111111',
    contrastText: '#FFFFFF',
  },
  
  // Neutral colors for text, backgrounds, etc.
  neutral: {
    white: '#FFFFFF',
    offWhite: '#F5F5F5',
    lightGrey: '#E0E0E0',
    grey: '#A0A0A0',
    darkGrey: '#666666',
    black: '#000000',
  },
  
  // Semantic colors for feedback
  feedback: {
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#F44336',
    info: '#2196F3',
  },
  
  // Gradients
  gradients: {
    darkRed: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(168, 0, 0, 0.2))',
    darkRedHover: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(218, 0, 0, 0.3))',
  },
  
  // Transparency values
  alpha: {
    light: 0.1,
    medium: 0.3,
    high: 0.8,
  },
};

export default colors; 